import config from "./config";

const scene1 = config['scene-1-7'];
const scene2 = config["scene-2"];
const scene3 = config["scene-3"];

export function preloadSceneSprites(
  scene: typeof scene1 | typeof scene2 | typeof scene3,
  onComplete: (
    scene: typeof scene1 | typeof scene2 | typeof scene3
  ) => void
) {
  const sprites = scene.sprites;
  const spriteCount = sprites.paths.length;

  let totalLoaded = 0;
  function imgOnload() {
    totalLoaded++;
    if (totalLoaded === spriteCount) {
      console.log("scene", scene.id, " sprites loaded");
      scene.imagesLoaded = true;
      onComplete(scene);
    }
  }

  sprites.paths.forEach((path) => {
    const img = new Image();
    sprites.images.push(img);
    img.onload = imgOnload;
    img.src = path;
  });
}

export function preloadScene4Videos(){
  const specs = document.querySelectorAll("#scene-4 .accordion-item");
  specs.forEach((spec) => {
    const videoSrc = spec.getAttribute('data-video-src');
    const preload = document.createElement("link");
    preload.rel = "preload";
    preload.as = "video";
    preload.href = videoSrc;
    document.head.appendChild(preload);
  });
}

// export function preloadSceneFrames(
//   scene: typeof scene1 | typeof scene2 | typeof scene3,
//   onComplete: (scene: typeof scene1 | typeof scene2 | typeof scene3) => void
// ) {
//   const totalFrames = scene.totalFrames;
//   const imgPaths: Array<string> = [];

//   let totalLoaded = 0;
//   function imgOnload() {
//     totalLoaded++;
//     if (totalLoaded === totalFrames){
//       console.log('scene', scene.id, 'loaded');
//       scene.imagesLoaded = true;
//       onComplete(scene);
//     }
//   }

//   for (let i = 0; i < totalFrames; i++) {
//     let frameNumber = i + 1;
//     imgPaths.push(scene.getPath(frameNumber));
//   }
//   imgPaths.forEach((path) => {
//     const img = new Image();
//     scene.frames.push(img);
//     img.onload = imgOnload;
//     img.src = path;
//   });
// }

// function preloadImagesWithWorker(){
//   const workerNode = document.getElementById("landing-worker");
//   const blob = new Blob([workerNode.textContent], {
//     type: "application/javascript",
//   });
//   // window.addEventListener('load', function(){
//   //   navigator.serviceWorker.register(window.URL.createObjectURL(blob) ).then(function(registration){
//   //     navigator.serviceWorker.register("/sw.js").then(
//   //       function (registration) {
//   //         // Registration was successful
//   //         console.log(
//   //           "ServiceWorker registration successful with scope: ",
//   //           registration.scope
//   //         );
//   //       },
//   //       function (err) {
//   //         // registration failed :(
//   //         console.log("ServiceWorker registration failed: ", err);
//   //       }
//   //     );
//   //   });
//   // })
//   const ImageLoaderWorker = new Worker(window.URL.createObjectURL(blob));

//   ImageLoaderWorker.onmessage = function (event) {
//     console.log("Received message from worker", event.data);
//     try {
//       const data = JSON.parse(event.data);
//       if (data.type === 'imageLoadComplete'){
//         console.log("preloadImagesWithWorker: imageLoadComplete");
//         preloadSceneFrames(scene1);
//       } else if (data.type === 'scene2ImageLoadComplete'){
//         console.log("preloadImagesWithWorker: scene2ImageLoadComplete");
//         preloadSceneFrames(scene2);
//       } else if (data.type === 'scene3ImageLoadComplete'){
//         console.log("preloadImagesWithWorker: scene3ImageLoadComplete");
//         preloadSceneFrames(scene3);
//       }
//     } catch (e){
//       console.error(e);
//     }
//   };
//   ImageLoaderWorker.postMessage("post from window");
// }
